"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUploadDocumentUrlResponseToJSON = exports.GetUploadDocumentUrlResponseFromJSONTyped = exports.GetUploadDocumentUrlResponseFromJSON = void 0;
function GetUploadDocumentUrlResponseFromJSON(json) {
    return GetUploadDocumentUrlResponseFromJSONTyped(json, false);
}
exports.GetUploadDocumentUrlResponseFromJSON = GetUploadDocumentUrlResponseFromJSON;
function GetUploadDocumentUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': json['url'],
        'fileName': json['fileName'],
    };
}
exports.GetUploadDocumentUrlResponseFromJSONTyped = GetUploadDocumentUrlResponseFromJSONTyped;
function GetUploadDocumentUrlResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
        'fileName': value.fileName,
    };
}
exports.GetUploadDocumentUrlResponseToJSON = GetUploadDocumentUrlResponseToJSON;
